export const formatNumber = (number, decimals) => {
  if (number == null)
    return null;

  return number.toLocaleString('da-DK', {minimumFractionDigits: decimals || 0, maximumFractionDigits: decimals || 0});
};
